import { render, staticRenderFns } from "./CTC_Intro.vue?vue&type=template&id=5816a27e&scoped=true"
import script from "./CTC_Intro.vue?vue&type=script&lang=js"
export * from "./CTC_Intro.vue?vue&type=script&lang=js"
import style0 from "./CTC_Intro.vue?vue&type=style&index=0&id=5816a27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816a27e",
  null
  
)

export default component.exports